<template>
  <div id="app">
    <router-view />
    <BlockUI :message="'Carregando...'" v-if="loading">
      <div>
        <b-spinner label="Loading..."></b-spinner>
      </div>
    </BlockUI>
    <notifications group="foo" />
  </div>
</template>

<script>
export default {
  name: 'App',
  computed: {
    loading () {
      return this.$store.getters.activeRequests
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue